<template>
    <div class="container">
        <div class="nav_header">
            <h2>资料编辑</h2>
        </div>

        <el-form ref="form" :model="form" label-width="150px" class="form" :rules="rules">
            <el-form-item label="姓名" prop="name">
                <el-input v-model="form.name"></el-input>
            </el-form-item>

            <el-form-item label="邮箱" prop="email">
                <el-input v-model="form.email"></el-input>
            </el-form-item>

            <el-form-item label="QQ号码" prop="qq">
                <el-input v-model="form.qq"></el-input>
            </el-form-item>

            <white-space />
            <el-form-item v-if="form.id">
                <el-button @click="submit" class="pointer" type="primary" :disabled="disabled">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
    const requestUrl = "/personal/profile";
    export default {
        data() {
            return {
                disabled: false,
                form: {
                    name: "",
                    email: "",
                    qq: "",
                    mobile: "",
                },
                rules: {
                    name: [
                        {
                            required: true,
                            message: "请输入姓名",
                            trigger: "blur",
                        },
                    ],
                    email: [
                        {
                            type: "email",
                            message: "邮箱格式错误",
                            trigger: "blur",
                        },
                    ],
                },
            };
        },
        created() {
            this.load();
            this.$store.commit("changeOwnActive", "personal-profile");
        },
        methods: {
            load() {
                //url参数
                this.params = Object.assign({}, this.params, this.$route.query);

                this.$http.get(requestUrl + window.location.search).then((response) => {
                    if (response.success) {
                        this.form = response.data;

                        this.$store.commit("changeProfile", response.data);
                    }
                });
            },
            submit() {
                this.$refs["form"].validate((valid) => {
                    if (valid) {
                        this.disabled = true;
                        this.$http
                            .post("personal/profile", this.form)
                            .then((response) => {
                                if (!response.success) {
                                    this.$alert(response.message, "失败", {
                                        type: "error",
                                        showCancelButton: false,
                                    });
                                } else {
                                    this.$alert("信息修改成功", "成功", {
                                        type: "success",
                                        showCancelButton: false,
                                    });
                                }

                                this.load();
                            })
                            .catch()
                            .then(() => {
                                this.disabled = false;
                            });
                    } else {
                        return false;
                    }
                });
            },
        },
    };
</script>

<style scoped lang="less">
    .container {
        .form {
            width: 460px;
        }

        textarea {
            resize: none;
        }

        label {
            margin-right: 12px;
        }
        textarea:focus {
            outline: none;
            border: 1px solid #f08c19 !important;
        }
        .el-alert--error {
            width: 500px;
            background-color: #fef0f0;
            color: #f56c6c;
            margin-top: 2px;
            margin-bottom: 2px;
            position: relative;
            right: -100px;
        }
    }
</style>
